var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99988 1.00003C6.61543 1.00005 5.26208 1.41061 4.11095 2.17978C2.95983 2.94895 2.06264 4.04219 1.53284 5.32126C1.00304 6.60033 0.864413 8.00777 1.1345 9.36563C1.40459 10.7235 2.07125 11.9707 3.0502 12.9497C3.69904 13.605 4.47096 14.1256 5.32161 14.4816C6.17226 14.8376 7.08487 15.0221 8.00702 15.0244C8.92917 15.0266 9.84268 14.8467 10.6951 14.4948C11.5475 14.143 12.3219 13.6262 12.974 12.9741C13.6261 12.3221 14.1429 11.5476 14.4947 10.6952C14.8465 9.84282 15.0265 8.92931 15.0242 8.00716C15.022 7.08501 14.8375 6.1724 14.4815 5.32175C14.1254 4.4711 13.6048 3.69918 12.9496 3.05034C12.3011 2.39828 11.5297 1.88132 10.6801 1.52939C9.83049 1.17745 8.9195 0.997524 7.99988 1.00003ZM1.99988 8.00003C1.99988 4.69159 4.69145 2.00003 7.99988 2.00003V14C4.69145 14 1.99988 11.3085 1.99988 8.00003Z",
    fill: "url(#paint0_linear_4629_250122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4629_250122",
    x1: 22.0364,
    y1: 8.0122,
    x2: 8.01198,
    y2: -6.01205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05F5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrast);
export default __webpack_public_path__ + "static/media/contrast.3eb1762cfe69e880dbd36deba175ab94.svg";
export { ForwardRef as ReactComponent };